import React from 'react';
import './LevelProgressBar.css';
import InfoIcon from '../../../assets/info.svg';

/**
 * Level Progress Bar Component
 * Displays current level, progress to next level, and rank
 * Based on Figma LevelCard design with gold gradient
 */
const LevelProgressBar = ({ 
  level = 1, 
  levelName = "Beginner",
  currentPoints = 0, 
  nextLevelPoints = 100, 
  rank = 1,
  onClick = () => {},
  onInfoIconHover,
  onInfoIconMove,
  onInfoIconLeave
}) => {
  const progress = nextLevelPoints > 0 ? (currentPoints / nextLevelPoints) * 100 : 0;
  const pointsToNext = nextLevelPoints - currentPoints;

  return (
    <div className="level-progress-bar" onClick={onClick}>
      {/* Trophy Icon with Level Number */}
      <div className="trophy-section">
        <div className="trophy-icon">
          <span className="trophy-rank">{level}</span>
        </div>
      </div>

      {/* Level Info with Tooltip */}
      <div className="level-info">
        <div className="level-title-row">
          <span className="level-title">Level {level}</span>
          {pointsToNext > 0 && onInfoIconHover && (
            <div 
              className="info-icon-wrapper"
              onMouseEnter={(e) => onInfoIconHover(e, pointsToNext)}
              onMouseMove={onInfoIconMove}
              onMouseLeave={onInfoIconLeave}
            >
              <img src={InfoIcon} alt="Info" className="info-icon" />
            </div>
          )}
        </div>
        {/* Remove the static subtitle */}
      </div>

      {/* Progress Bar */}
      <div className="progress-section">
        <div className="progress-bar-container">
          <div className="progress-bar-background"></div>
          <div 
            className="progress-bar-fill" 
            style={{ width: `${Math.min(progress, 100)}%` }}
          ></div>
          <div className="progress-text">
            {currentPoints}/{nextLevelPoints}
          </div>
        </div>
      </div>

      {/* Rank Badge */}
      <div className="rank-section">
        <div className="rank-badge">
          #{rank}
        </div>
      </div>

      {/* Background Progress Bar (subtle) */}
      <div className="background-progress">
        <div 
          className="background-progress-fill" 
          style={{ width: `${Math.min(progress, 100)}%` }}
        />
      </div>

    </div>
  );
};

export default LevelProgressBar;
